import { Component, OnInit, Input, Output, EventEmitter, ContentChildren, QueryList, AfterViewInit, OnChanges } from '@angular/core';
import { RDSelectOptionComponent } from './select-option/select-option.component';
import { RDDarkService } from '../dark.service';

@Component({
  selector: 'rd-select',
  template: `<div class="selectContainer {{color}}Select" [class.open]="open" [class.rdDark]="dark">
  <div class="selectValue" (click)="open = !open">
    <div class="placeholder" [class.focus]="open || text !== ''">{{placeholder || 'Select'}}</div>
    <div class="input">{{text}}</div>
  </div>
  <div class="selectMenu" (click)="open = false">
    <ng-content></ng-content>
  </div>
</div>
`,
  styles: [`.selectContainer{--main-color:#ba9e5a;--text-color:black;--background-color:white;width:100%;position:relative}.selectContainer .selectValue{position:relative;margin-top:20px;border-bottom:1px var(--main-color) solid;font-size:16px;height:20px;color:var(--text-color)}.selectContainer .selectValue .placeholder{position:absolute;transition:all .2s ease-in;z-index:0}.selectContainer .selectValue .placeholder.focus{font-size:12px;-webkit-transform:translateY(-100%);transform:translateY(-100%);color:var(--main-color)}.selectContainer .selectValue .input{z-index:1;height:100%}.selectContainer .selectMenu{position:absolute;top:auto;left:auto;min-width:inherit;width:100%;background-color:var(--background-color);color:var(--text-color);box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);padding:6px 0;z-index:1}.selectContainer:not(.open)>.selectMenu{display:none}.selectContainer.blackSelect{--main-color:black}.selectContainer.greenSelect{--main-color:#72ba5a}.selectContainer.blueSelect{--main-color:#5a5aba}.selectContainer.blue-lightSelect{--main-color:#5aa2ba}.selectContainer.redSelect{--main-color:#ba5a5a}.selectContainer.purpleSelect{--main-color:#a25aba}.selectContainer.orangeSelect{--main-color:#ba8a5a}.selectContainer.rdDark{--text-color:white;--background-color:#07384c}`]
})
export class RDSelectComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() value = '';
  @Input() placeholder = '';
  @Input() color = 'gold';

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  @ContentChildren(RDSelectOptionComponent) options: QueryList<RDSelectOptionComponent>;

  public open = false;
  public text = '';
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  ngAfterViewInit() {
    this.options.forEach(option => {
      option.valueSelected.subscribe((event) => {
        this.value = event;
        this.valueChange.emit(this.value);
        this.text = (option.text !== '') ? option.text : option.value;
        this.open = false;
      });
    });
    this.changeText();
  }

  ngOnChanges(changes) {
    this.changeText();
  }

  changeText() {
    if (this.options && this.value !== '') {
      this.options.forEach(option => {
        if (option.value === this.value) {
          this.text = (option.text !== '') ? option.text : option.value;
        }
      });
    }
  }

}
